import { Model } from "./Concers/Model";
import { ContactPerson } from "./ContactPerson";

export class Contact extends Model {
    id: number;
    title: string;
    sub_title: string;
    email: string;
    phone: string;
    mobile_phone?: string;
    photo: string;
    has_whatsapp?: number;
    contact_persons: ContactPerson[] = [];
    isActive: boolean = false;

    public translatable = [
        "is_active",
        "title",
        "sub_title",
        "email",
        "phone",
        "mobile_phone"
    ];

    constructor(item) {
        super(item);

        const contactPersonsData =
            item?.contact_persons ?? item?.contactPersons;

        if (contactPersonsData && Array.isArray(contactPersonsData)) {
            this.contact_persons = contactPersonsData.map(
                (person) => new ContactPerson(person)
            );
        }
    }
}
